// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiShowInferencer } from "@refinedev/inferencer/mui";

// export const ActionShow: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiShowInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };

import { ArrowDownwardTwoTone, ArrowUpwardTwoTone } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { useOne, useShow } from "@refinedev/core";
import {
  DateField,
  NumberField,
  Show,
  TagField,
  TextFieldComponent as TextField,
} from "@refinedev/mui";
import { ActionType } from "./create";

export const ActionShow = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record = data?.data;

  const { data: containerData, isLoading: containerIsLoading } = useOne({
    resource: "containers",
    id: record?.container || "",
    queryOptions: {
      enabled: !!record,
    },
  });

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          Type
        </Typography>
        <Typography variant="body2" fontWeight="bold" width={100}>
          {record?.type === ActionType.IN ? (
            <Stack alignItems="center" direction="row" spacing={2}>
              <ArrowDownwardTwoTone fontSize="small" sx={{ color: "green" }} />
              <span>IN</span>
            </Stack>
          ) : record?.type === ActionType.OUT ? (
            <Stack alignItems="center" direction="row" spacing={2}>
              <ArrowUpwardTwoTone fontSize="small" sx={{ color: "red" }} />
              <span>OUT</span>
            </Stack>
          ) : (
            "- -"
          )}
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          Quantity
        </Typography>
        <NumberField value={record?.quantity ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Created At
        </Typography>
        <DateField value={record?.createdAt} />
        <Typography variant="body1" fontWeight="bold">
          Date
        </Typography>
        <NumberField value={record?.date ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Customer Type
        </Typography>
        <TextField value={record?.customer_type} />
        <Typography variant="body1" fontWeight="bold">
          Container
        </Typography>

        {record?.container?.type}

        <br />

        {record?.customer_type === "FARMER" && (
          <>
            <Typography variant="body1" fontWeight="bold">
              Farmer
            </Typography>
            {record?.farmer?.name}
          </>
        )}

        {record?.customer_type === "CLIENT" && (
          <>
            <Typography variant="body1" fontWeight="bold">
              Client
            </Typography>
            {record?.client?.name}
          </>
        )}

        <Typography variant="body1" fontWeight="bold">
          Product Lists
        </Typography>
        <Stack direction="row" spacing={1}>
          {record?.product_lists?.map((item: any) => (
            <TagField value={item?.name} key={item?.name} />
          ))}
        </Stack>
      </Stack>
    </Show>
  );
};
